import ControlFactory from '@/Factories/ControlFactory';
import LDAPSearchViewModel from '@/ViewModels/Controls/LDAPSearchViewModel';
import LDAPSearch from '@/Controls/LDAPSearch';
import LDAPSearchViewModelT from '@/ViewModels/Controls/LDAPSearchViewModel';
import ComponentManager from '@/Management/ComponentManager';
export default class LDAPSearchDialogFactory extends ControlFactory {
    /** Overrides */
    public control: LDAPSearch;
    /** Overrides */
    public viewModel: LDAPSearchViewModel;
    private LDAPSearchViewModel: any;
    private LDAPSearch: any;
    private jQueryControl: JQuery;
    constructor(params: any) {
        super(params);
        this.jQueryControl = null;
        this.LDAPSearchViewModel = ComponentManager.getViewModel<typeof LDAPSearchViewModelT>('LDAPSearchViewModel');
        this.LDAPSearch = ComponentManager.getControl('LDAPSearch');
    }
    /** Overrides */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        this.viewModel = (() => {
            return new this.LDAPSearchViewModel({
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                context: this.context
            });
        })();
        this.control = (() => {
            return new this.LDAPSearch(this.viewModel);
        })();
        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;
        return this.jQueryControl;
    }
}

ComponentManager.setFactory('LDAPSearchDialog', LDAPSearchDialogFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('RADPresentation.DefaultViewExtensions.UIComponents.LDAPSearchDialog', LDAPSearchDialogFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');